import { Dropdown } from "react-bootstrap";

import {
  MediaGroup,
  Media,
  MediaText,
  Image,
  Icon,
  CustomDropdownToggle,
  CustomDropdownMenu,
  LinkList,
  LinkListItem,
} from "../../components";
import { MdDelete } from "react-icons/md";
import { handleDeleteCategory } from "../../pages/categories-manage/CategoriesList";
import instance from "../../pages/api";
import { createPortal } from "react-dom";
import { imageUrl } from "../../pages/api";
import Swal from "sweetalert2";
import { useState } from "react";
import { ChevronDown } from "lucide-react";
export const userColumns = ({ setCategoriesData }) => {
  const handleStatusUpdate = async (category_id, newStatus) => {
    try {
      // Make the PUT request to update the status
      await instance.put(
        `api/Category/update/${category_id}`,

        // `api/Master/Country/update/${country_id}`,
        { status: String(newStatus) }
      );

      // if (response.status === 200) {
      // console.log("Response is ok");
      // If the response is OK, update the state to reflect the new status
      setCategoriesData((prevData) =>
        prevData.map((cat) =>
          cat.category_id === category_id ? { ...cat, status: newStatus } : cat
        )
      );
      Swal.fire("Success", "Category Status updated successfully!", "success");
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire("Error", "Failed to update Category Status!", "error");
    }
  };
  return [
    {
      name: "Category ID",
      selector: (row) => row.category_id,
      cell: (row) => <span>{row.category_id}</span>,
      sortable: true,
      maxWidth: "150px",
    },

    {
      name: "Category Name",
      selector: (row) => row.name,
      
      cell: (row) => (
        <MediaGroup>
          <Media
            className="rest-image-last"
            size="md"
            shape="circle"
            variant={row.theme && row.theme}
          >
            {row.image ? (
              <Image src={`${imageUrl}${row.image}`} staticImage />
            ) : (
              ""
            )}
          </Media>
          <MediaText>
            <span className="small text" style={{ whiteSpace: "normal", wordBreak: "normal" }}>
          {row.name}
        </span>
            {/* <span className="small text" style={{ whiteSpace: "nowrap" }}>
              {row.name}
            </span> */}
          </MediaText>
        </MediaGroup>
      ),
      sortable: true,
      flexGrow: 1, 
    },
    // {
    //   name: "Created Date",
    //   selector: (row) => row.createdAt,
    //   cell: (row) => <span>{new Date(row.createdAt).toDateString()}</span>,
    //   sortable: true,
    //   minWidth: "150px",
    // },
    {
      name: "No. Of Products",
      selector: (row) => row.products_count,
      cell: (row) => <span>{row.products_count}</span>,
      sortable: true,
      maxWidth: "200px",
    },
    
    // {
    //   name: "Order",
    //   selector: (row) => row.sort_order,
    //   cell: (row) => <span>{row.sort_order}</span>,
    //   sortable: true,
    // },

    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <StatusCell row={row} onStatusChange={handleStatusUpdate} />

        // <div
        //   className={`d-flex justify-content-center align-items-center rounded`}
        //   style={{
        //     color: row.status === 1 ? "#198754" : "#dc3545", // Bootstrap success and danger text colors
        //     backgroundColor: row.status === 1 ? "#d1e7dd" : "#f8d7da", // Bootstrap success and danger light backgrounds
        //     width: "93px",
        //     height: "28px",
        //     cursor: "pointer",
        //   }}
        //   onClick={() => console.log(row.status)}
        // >
        //   {row.status == 1 ? "Active" : "Inactive"}
        // </div>
      ),
      sortable: true,
      maxWidth: "200px",
    },

    {
      name: "action",
      cell: (row) => (
        <div className="text-end w-100">
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              as={CustomDropdownToggle}
              className="btn btn-sm btn-icon btn-zoom me-n1"
            >
              <Icon name="more-v"></Icon>
            </Dropdown.Toggle>
            {createPortal(
              <Dropdown.Menu
                className="dropdown-menu-sm"
                as={CustomDropdownMenu}
                align="end"
              >
                <div className="dropdown-content py-1">
                  <LinkList className="link-list-hover-bg-primary link-list-md">
                    <LinkListItem
                      to={`/categories-manage/categories-list/${row.category_id}`}
                    >
                      <Icon name="edit"></Icon>
                      <span>Edit</span>
                    </LinkListItem>

                    <LinkListItem
                      className="delete-ittem"
                      to="#"
                      onClick={() =>
                        handleDeleteCategory(row.category_id, setCategoriesData)
                      }
                    >
                      <MdDelete />
                      <span>Delete</span>
                    </LinkListItem>
                  </LinkList>
                </div>
              </Dropdown.Menu>,
              document.body
            )}
          </Dropdown>
        </div>
      ),
      sortable: false,
      maxWidth: "100px",
    },
  ];
};

const StatusCell = ({ row, onStatusChange }) => {


  const handleStatusChange = (newStatus) => {
    // Call the onStatusChange function passed from the parent
    onStatusChange(row.category_id, newStatus);
    // Hide the dropdown after selection
    // setDropdownVisible(false);
  };

  return (
    <div className="text-center ">
      <Dropdown>
        <Dropdown.Toggle
          size="sm"
          as={CustomDropdownToggle}
          className="btn-zoom"
        >
          <div
            className={`d-flex justify-content-center align-items-center rounded`}
            style={{
              color: row.status === 1 ? "#198754" : "#dc3545",
              backgroundColor: row.status === 1 ? "#d1e7dd" : "#f8d7da",
              width: "93px",
              height: "28px",
              cursor: "pointer",
            }}
          >
            {row.status === 1 ? "Active" : "Inactive"}{" "}
            {row.status === 1 ? (
              <ChevronDown color="#198754" size={18} />
            ) : (
              <ChevronDown color="#dc3545" size={18} />
            )}
          </div>
        </Dropdown.Toggle>
        {createPortal(
          <Dropdown.Menu
            className="dropdown-menu-sm"
            as={CustomDropdownMenu}
            align="end"
          >
            <div className="dropdown-content py-1">
              <LinkList className="link-list-hover-bg-primary link-list-md">
                <button
                  className="dropdown-item"
                  onClick={() => handleStatusChange(1)}
                >
                  Active
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => handleStatusChange(0)}
                >
                  Inactive
                </button>
              </LinkList>
            </div>
          </Dropdown.Menu>,
          document.body
        )}
      </Dropdown>
    </div>

    
  );
};
